import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { LoginButton } from "../../buttons/login-button";
import { SignupButton } from "../../buttons/signup-button";
import { useNavigate } from "react-router-dom";
import { NavBarMenu } from "./nav-bar-menu";

export const NavBarButtons: React.FC = () => {
  const { isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  const handleProfileClick = () => {
    navigate('/profile');
  };

  return (
    <div className="nav-bar__buttons">
      {!isAuthenticated && (
        <>
          <SignupButton />
          <LoginButton />
        </>
      )}
      {isAuthenticated && (
        <>
          <button className="profile-icon-button" onClick={handleProfileClick} title="My account">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <span className="profile-icon-button__label">My account</span>
          </button>
          <NavBarMenu />
        </>
      )}
    </div>
  );
};
